import { analytics, PlaybackEvent, PlaybackEventEmitter, usePlaylistStateStore, } from '@annunciate/core';
import { fetchValidStream } from '@annunciate/query';
export const onAttemptAdvancePlaylist = async (client, currentId) => {
    if (currentId === undefined || currentId < 0)
        return;
    const { activePlaylistItems = [], } = usePlaylistStateStore.getState();
    const idx = activePlaylistItems?.findIndex((id) => id === currentId);
    const next = activePlaylistItems[idx + 1];
    if (next) {
        const { content } = await fetchValidStream(client, next);
        PlaybackEventEmitter.emit(PlaybackEvent.START, {
            content,
            auto: true,
        });
    }
    else {
        await analytics.emitPlaybackEvent("completed");
    }
};
//# sourceMappingURL=onAttemptAdvancePlaylist.js.map